export default __webpack_public_path__ + "static/jensen-het-vrije-geluid-2b38dcf07d6181b8804cdbd1993ba7d2.png";